import { fetchImage } from '@/api/image.api';
import { Events } from '@/services/Events';
import { t } from '@/translations/i18n';
import type { IImageField } from '@/typescript/interfaces/IImageField';
import type { ITemplate } from '@/typescript/interfaces/ITemplate';

async function initTemplateImages(template: ITemplate) {
    const fields = await Promise.all(
        template.configuration.fields.map(async (field) => {
            if (!('uuid' in field)) {
                return field;
            }

            const imgField = field as IImageField;
            if (!imgField.uuid) {
                return field;
            }
            try {
                const imgBlob = await fetchImage(imgField.uuid);
                imgField.url = URL.createObjectURL(imgBlob);
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch (e) {
                Events.emit('call-toaster', {
                    title: t('error_title'),
                    body: t('image_load_error', { name: imgField.filename || '' }),
                    type: 'error',
                });
            }

            return imgField;
        }),
    );

    return {
        ...template,
        configuration: {
            ...template.configuration,
            fields,
        },
    };
}

export { initTemplateImages };
